const typePolicies = {

    _ASSISTANT_: 'Assistant',
    _ASSISTANT_Item: 'ItemDemo'

}
export default typePolicies